import { observer } from 'src/utils/mobx-react';
import { YaspaState } from './YaspaSegment.state';
import React from 'react';
import { Popup } from 'src/components/Popup/Popup';
import { YaspaIFrameStyled } from './YaspaSegment.style';

interface YaspaSegmentPropsType {
    yaspaState: YaspaState;
}

export const YaspaPopup = observer('YaspaPopup', ({ yaspaState }: YaspaSegmentPropsType): JSX.Element | null => {
    if (yaspaState.popup.isOpen === false) {
        return null;
    }

    return (
        <Popup
            title='Yaspa Withdrawal'
            priority={120000}
            active={true}
            onClose={yaspaState.handleClose}
        >
            <YaspaIFrameStyled
                src={yaspaState.popup.src}
                title='yaspa-iframe'
                data-test='yaspa-iframe'
            />
        </Popup>
    );
});
